export const createAction = (type, payload = {}, error = false) => ({
	type,
	payload,
	error,
});

export const logAmplitudeEvent = (eventName, eventProperties = {}) => {
	const delays = [100, 250, 500, 1000, 4000];

	try {
		const tryWithDelay = (attempt = 0) => {
			setTimeout(() => {
				if (window.amplitude) {
					window.amplitude.logEvent(eventName, eventProperties);
				} else if (attempt + 1 < delays.length) {
					tryWithDelay(attempt + 1);
				} else {
					console.warn("Amplitude event not sent:", {
						eventName,
						eventProperties,
					});
				}
			}, delays[attempt]);
		};

		if (window.amplitude) {
			window.amplitude.logEvent(eventName, eventProperties);
		} else {
			tryWithDelay();
		}
	} catch (error) {
		console.error("Error logging amplitude event:", error);
	}
};
